<template>
  <header
    class="w-full h-20 lg:h-28 flex justify-center items-center z-20 bg-white"
  >
    <component
      :is="link ? 'inertia-link' : 'div'"
      :href="link ? $route('home') : undefined"
      :aria-label="link ? 'Home' : undefined"
    >
      <img src="/storage/images/logo.svg" alt="Youverse" class="w-40 h-auto" />
    </component>
  </header>
</template>
<script>
export default {
  props: {
    link: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
